// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".\\---base-ui-link__link {\n  color: inherit;\n}\n.\\---base-ui-link__isSubtle {\n  text-decoration: none;\n}\n", "",{"version":3,"sources":["webpack://./../base/ui/link.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB","sourcesContent":[".link {\n  color: inherit;\n}\n.isSubtle {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "---base-ui-link__link",
	"isSubtle": "---base-ui-link__isSubtle"
};
export default ___CSS_LOADER_EXPORT___;
